/**
 * HubSwitcher — quick links to the 8 Corporate Tools hubs on the right side.
 * Shows full readable labels with colorful icons.
 */
import { Link, useLocation } from "react-router-dom";
import {
  Briefcase, MessageSquare, Users, Lightbulb, BookOpen,
  Package, Plane, LayoutDashboard,
} from "lucide-react";

const HUBS = [
  { to: "/smart-office", label: "Smart Office", icon: Briefcase, color: "bg-blue-500" },
  { to: "/comms-centre", label: "COMMS", icon: MessageSquare, color: "bg-emerald-500" },
  { to: "/hr-hub", label: "HR", icon: Users, color: "bg-purple-500" },
  { to: "/innovation-centre", label: "Innovator", icon: Lightbulb, color: "bg-amber-500" },
  { to: "/knowledge-centre", label: "Knowledge Base", icon: BookOpen, color: "bg-cyan-500" },
  { to: "/logistics", label: "Logistic Centre", icon: Package, color: "bg-orange-500" },
  { to: "/travelling", label: "Travel Module", icon: Plane, color: "bg-rose-500" },
  { to: "/erp", label: "ERP", icon: LayoutDashboard, color: "bg-indigo-500" },
];

export default function HubSwitcher() {
  const location = useLocation();

  const isActive = (to) => {
    if (to === "/") return location.pathname === "/";
    return location.pathname.startsWith(to);
  };

  return (
    <div>
      <h3 className="text-xs uppercase tracking-wider text-app-secondary font-semibold mb-2">Corporate Tools</h3>
      <div className="flex flex-col gap-1">
        {HUBS.map((h) => {
          const active = isActive(h.to);
          const Icon = h.icon;
          return (
            <Link
              key={h.to}
              to={h.to}
              className={`flex items-center gap-2 px-3 py-2 rounded-md text-xs transition-colors ${
                active
                  ? "bg-white/10 text-white font-medium"
                  : "text-app-secondary hover:text-app hover:bg-white/5"
              }`}
              title={h.label}
            >
              <div className={`w-5 h-5 rounded ${h.color} flex items-center justify-center shrink-0`}>
                <Icon className="w-3 h-3 text-white" />
              </div>
              <span>{h.label}</span>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
